var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logger",class:[this.variant === 'warning' ? 'logger--warning' : 'logger--error']},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.logs),function(log,key){return _c('div',{key:key},[_vm._v(" "+_vm._s(key + 1)+") "+_vm._s(log)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }